import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetokhatushyamtourpackage() {



  const cardData =
  {
    keyword: 'Pune to Khatu Shyam Tour Package',
    heading: 'Sanavi Travels: Pune to Khatu Shyam Tour Package',
    headingDescription: 'Sanavi Travels offers Pune to Khatu Shyam Tour Package, providing safe, comfortable, and well-organized transportation for devotees, families, and group pilgrimage tours to the famous Khatu Shyam temple. Our fleet of well-maintained AC and Non-AC buses, mini buses, and luxury coaches ensures spacious seating, smooth long-distance travel, and ample luggage space for a hassle-free journey. With experienced drivers, flexible one-way and round-trip tour packages, transparent pricing, and 24/7 booking support, the Pune to Khatu Shyam tour package guarantees punctual, reliable, and stress-free travel. Choose Sanavi Travels for trusted Pune to Khatu Shyam bus tour services, delivering comfort, safety, and convenience for a memorable and divine pilgrimage experience.',

    top: 'Top Places to Visit in Khatu Shyam with Sanavi Travels',


"topPlaces": [
  {
    "title": "Khatu Shyam Temple",
    "description": "Khatu Shyam Temple, located in Khatu village of Sikar district, Rajasthan, is a revered pilgrimage site dedicated to Lord Shyam, believed to be an incarnation of Barbarika, the grandson of Bhima from the Mahabharata. The temple is famous for its miraculous powers, and devotees from across India flock here to seek blessings, fulfill vows, and participate in spiritual rituals. The sanctum houses a decorated idol adorned with ornaments and flowers, exuding divine energy."
  },
  {
    "title": "Khatu Shyamji Fair (Shyam Mahotsav)",
    "description": "The temple hosts an annual fair, especially during Phalguna Shukla Ekadashi, attracting thousands of devotees. The fair is a vibrant blend of devotion, cultural performances, folk music, and rituals. Pilgrims often carry offerings and participate in processions, making it a spiritually and culturally enriching experience."
  },
  {
    "title": "Mandir Complex and Architecture",
    "description": "The Khatu Shyam temple complex showcases traditional Rajasthani architecture with marble floors, intricate carvings, and beautifully decorated interiors. The spacious courtyard allows devotees to gather for prayers and ceremonies. The main sanctum is the heart of spiritual activity, where the deity’s darshan is considered highly auspicious."
  },
  {
    "title": "Barbarika’s Legend and Spiritual Significance",
    "description": "According to legend, Barbarika sacrificed his head before the Kurukshetra war and blessed devotees with victories and fulfillment of wishes. Khatu Shyam is worshipped as a deity of truth, courage, and devotion. Pilgrims believe that sincere prayers here bring relief from difficulties, success in endeavors, and protection from adversities."
  },
  {
    "title": "Nearby Hanuman Temple",
    "description": "Close to Khatu Shyam Temple, a Hanuman temple adds to the spiritual ambiance. Devotees often visit both temples during their pilgrimage, performing rituals, offering prayers, and seeking divine protection."
  },
  {
    "title": "Accommodation and Pilgrim Facilities",
    "description": "Khatu village offers dharamshalas, guest houses, and facilities for pilgrims to stay comfortably during their visit. These accommodations ensure that devotees from faraway regions can undertake their pilgrimage with ease and devotion."
  },
  {
    "title": "Local Cuisine and Markets",
    "description": "The temple area features local markets offering religious souvenirs, handicrafts, and traditional Rajasthani snacks. Visitors can enjoy local cuisine and purchase devotional items, enhancing the overall pilgrimage experience."
  },
  {
    "title": "Festivals and Rituals",
    "description": "Apart from the annual fair, Khatu Shyam Temple celebrates various Hindu festivals such as Janmashtami, Holi, and Diwali with grand rituals and decorations. These occasions provide an immersive cultural and spiritual experience for devotees."
  },
  {
    "title": "Spiritual Practices and Offerings",
    "description": "Devotees perform various rituals such as aarti, abhishek, and offering flowers, sweets, or chadars to Lord Shyam. Participating in these practices is believed to bring peace, spiritual upliftment, and fulfillment of wishes."
  },
  {
    "title": "Cultural and Historical Significance",
    "description": "Khatu Shyam Temple is not only a center of devotion but also a symbol of Rajasthan’s cultural heritage, blending mythology, history, and architecture. The site continues to inspire faith, community participation, and reverence across generations."
  }
]
,



"services": [
{
"name": "Pune to Khatu Shyam Tour Package",
"description": "Pune to Khatu Shyam Tour Package offers a complete travel solution for devotees and tourists visiting the famous Khatu Shyam Temple in Rajasthan. This package includes comfortable bus travel, well-planned itineraries, and sightseeing opportunities, ensuring a smooth and memorable pilgrimage experience for families, groups, and individuals."
},
{
"name": "Khatu Shyam Bus Hire from Pune",
"description": "Khatu Shyam Bus Hire from Pune provides reliable and convenient bus rental services for long-distance travel to Khatu Shyam. Equipped with spacious seating, modern amenities, and professional drivers, these buses make the journey comfortable and safe for tourists and pilgrims alike."
},
{
"name": "AC Bus Pune to Khatu Shyam",
"description": "AC Bus Pune to Khatu Shyam ensures a cool and relaxing ride during the long-distance pilgrimage. These air-conditioned buses are ideal for families, groups, and individuals seeking comfort during their journey to Rajasthan."
},
{
"name": "Luxury Bus Khatu Shyam Darshan",
"description": "Luxury Bus Khatu Shyam Darshan offers premium travel options for those looking for extra comfort and convenience. With plush seating, ample legroom, and modern interiors, these buses make long-distance travel from Pune to Khatu Shyam a luxurious experience."
},
{
"name": "Religious Tour Bus Pune",
"description": "Religious Tour Bus Pune caters to pilgrims traveling to Khatu Shyam and other sacred sites. These buses provide safe, comfortable, and well-organized transportation for devotees, ensuring a spiritually fulfilling journey."
},
{
"name": "Family Khatu Shyam Trip",
"description": "Family Khatu Shyam Trip bus services are designed for family-friendly travel. With comfortable seating, smooth rides, and experienced drivers, these buses make long-distance pilgrimage trips safe and enjoyable for all age groups."
},
{
"name": "Group Travel Khatu Shyam Bus",
"description": "Group Travel Khatu Shyam Bus is perfect for clubs, tour operators, and large groups traveling together. High-capacity buses, organized itineraries, and professional drivers ensure a seamless journey for group travelers heading to Khatu Shyam."
},
{
"name": "Affordable Khatu Shyam Tour",
"description": "Affordable Khatu Shyam Tour provides budget-friendly bus travel options without compromising on comfort or safety. Ideal for students, families, and group travelers seeking economical solutions for a long-distance pilgrimage."
},
{
"name": "Chauffeur Driven Bus Khatu Shyam",
"description": "Chauffeur Driven Bus Khatu Shyam ensures a stress-free journey with skilled drivers handling long-distance routes. Passengers can relax and enjoy the scenic routes of Rajasthan during their trip from Pune to Khatu Shyam."
},
{
"name": "Best Khatu Shyam Package Pune",
"description": "Best Khatu Shyam Package Pune is known for its reliable buses, comfortable travel experience, and customer satisfaction. Perfect for family tours, group trips, and luxury journeys, it ensures timely departures and well-organized itineraries."
},
{
"name": "Pune Khatu Shyam Travel Bus",
"description": "Pune Khatu Shyam Travel Bus offers organized and dependable bus services for tourists and devotees traveling from Pune to Khatu Shyam. With professional drivers, safe travel arrangements, and comfortable buses, it simplifies long-distance travel."
},
{
"name": "Pilgrimage Bus Rental Pune",
"description": "Pilgrimage Bus Rental Pune specializes in providing buses for religious tours, including trips to Khatu Shyam. With a focus on safety, comfort, and convenience, these buses are ideal for devotees and pilgrimage groups."
},
{
"name": "Online Bus Booking Khatu Shyam",
"description": "Online Bus Booking Khatu Shyam provides an easy and convenient platform to reserve buses for the pilgrimage from Pune. Travelers can select bus types, schedules, and confirm bookings quickly, ensuring a hassle-free travel experience."
},
{
"name": "Rajasthan Temple Tour",
"description": "Rajasthan Temple Tour service offers bus travel for exploring Khatu Shyam and other prominent temples in Rajasthan. Comfortable buses, professional chauffeurs, and organized itineraries ensure a spiritually enriching journey."
},
{
"name": "Devotional Bus Tour",
"description": "Devotional Bus Tour provides specialized bus services for religious travelers visiting Khatu Shyam. Focused on comfort, safety, and organized travel, these buses enhance the overall pilgrimage experience from Pune to Rajasthan."
}
],
"tableData": [
["Pune to Khatu Shyam Tour Package", "Khatu Shyam Bus Hire from Pune"],
["AC Bus Pune to Khatu Shyam", "Luxury Bus Khatu Shyam Darshan"],
["Religious Tour Bus Pune", "Family Khatu Shyam Trip"],
["Group Travel Khatu Shyam Bus", "Affordable Khatu Shyam Tour"],
["Chauffeur Driven Bus Khatu Shyam", "Best Khatu Shyam Package Pune"],
["Pune Khatu Shyam Travel Bus", "Pilgrimage Bus Rental Pune"],
["Online Bus Booking Khatu Shyam", "Rajasthan Temple Tour"],
["Devotional Bus Tour", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Khatu Shyam Tour Package with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers a comfortable and reliable Pune to Khatu Shyam bus tour package, perfect for group trips, family tours, and pilgrimage journeys."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, air-conditioned, and regularly serviced, ensuring a smooth and enjoyable journey from Pune to Khatu Shyam."
  },
  {
    "WhyChooseheading": "Experienced Long-Distance Drivers",
    "WhyChoosedescription": "Our licensed drivers are skilled in long-distance travel, ensuring safe, timely, and hassle-free trips for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear pricing for Pune to Khatu Shyam bus tour packages, including fuel, tolls, and driver allowances with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, itinerary planning, and travel queries."
  },
  {
    "WhyChooseheading": "Customizable Tour Itineraries",
    "WhyChoosedescription": "You can customize your tour itinerary to include temple visits, sightseeing, and rest stops according to your preferences."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before departure to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Khatu Shyam bus tours."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels offer Pune to Khatu Shyam tour packages?',
    answer: 'Yes, Sanavi Travels provides Pune to Khatu Shyam bus tour packages suitable for group travel, pilgrimages, and family trips.'
  },
  {
    question: 'How can I book a Pune to Khatu Shyam tour?',
    answer: 'You can book the tour package through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for this tour?',
    answer: 'Sanavi Travels offers mini buses, 20-seater, 32-seater, 45-seater, and 50-seater buses based on your group size.'
  },
  {
    question: 'Can I customize the itinerary?',
    answer: 'Yes, you can tailor the itinerary to include temple visits, sightseeing, and rest stops as per your preference.'
  },
  {
    question: 'Are the drivers experienced with long-distance travel?',
    answer: 'Absolutely. Our drivers are licensed, professional, and familiar with long-distance routes like Pune to Khatu Shyam.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Khatu Shyam tour.'
  },
  {
    question: 'Are the buses sanitized before departure?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to ensure a safe and hygienic journey.'
  },
  {
    question: 'What payment methods are accepted?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for bookings.'
  },
  {
    question: 'Is this tour suitable for families and groups?',
    answer: 'Yes, the Pune to Khatu Shyam bus tour package is ideal for families, groups, and senior travelers.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Sharma',
    feedback: 'Our Pune to Khatu Shyam pilgrimage with Sanavi Travels was excellent! Comfortable bus, safe journey, and very professional service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sneha Mehta',
    feedback: 'Highly recommend Sanavi Travels for long-distance tours. Our trip to Khatu Shyam was smooth and well-organized.',
    rating: 5
  }
];



















































































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "BusTrip",
  "name": "Pune to Khatu Shyam Tour Package - Sanavi Travels",
  "description": "Sanavi Travels offers Pune to Khatu Shyam tour packages with AC and luxury buses. Ideal for religious trips, family visits, and group travel. Affordable, chauffeur-driven buses with online booking available.",
  "touristType": "Family Trip, Group Travel, Pilgrimage, Religious Tourism",
  "departureLocation": "Pune",
  "arrivalLocation": "Khatu Shyam, Rajasthan",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "20"
  }
};







  return (
    <div>

<Helmet>
  <title>
    Pune to Khatu Shyam Tour Package | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Pune to Khatu Shyam tour packages by Sanavi Travels. AC and luxury buses for religious trips, family visits, and group travel. Affordable, chauffeur-driven, with online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/202.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetokhatushyamtourpackage;